import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { updatePricing, updateGroupPricing } from "../../../../services/profile";
import { toast } from "react-toastify";
import { setLoading } from "../../../../reducer/auth/auth";


export default function DemonstrationsSessionsPricing(props) {
  const dispatch = useDispatch();
  const { stepOneData, id, onProfileUpdate } = props;
  const { coaching_pricing_30, coaching_pricing_60, session_currency } = stepOneData || {};
  const [practiceDemos, SetPracticeDemos] = useState(false);
    const [publicDemo, setPublicDemos] = useState(false);
   const { sessionPreferences } = useSelector((state) => state.user.user);
    const prefs = Array.isArray(sessionPreferences) ? sessionPreferences : [];
    // Both spellings accepted — see the rename note in the pricing index.
    const hasPracticeDemos =
      prefs.includes("Host Practice Demonstration") || prefs.includes("Practice Demos");
    const hasProfessionalSessions = prefs.includes("Professional Demonstrations");
    useEffect(() => {
      console.log("prefs", prefs);
      if (hasPracticeDemos) {
        SetPracticeDemos(true);
      }

      if (hasProfessionalSessions) {
        setPublicDemos(true);
      }
    }, []);
  useEffect(() => {
    console.log(stepOneData, "data");
  }, []);
  const handleSectionSubmit = (sectionName, values) => {
    const { session_currency, sessionPrices, coachingPrices, groupPrices, DemonstrationsPrices } = values;
let currency = session_currency;
    let item = {
      userId: id,
    };

    if (sectionName === "Demo") {
      let errors = [];

      const OPTIONAL_FIELD = "Practice Demo";
      const OPTIONAL_FIELD2 = "Professional Demo";

      Object.entries(DemonstrationsPrices).forEach(([key, value]) => {
        if (key === OPTIONAL_FIELD || key === OPTIONAL_FIELD2) return; // skip validation

        if (value === "" || value === null || isNaN(value) || Number(value) < 0) {
          errors.push(`${key} price is required.`);
        }
      });

      if (errors.length > 0) {
        errors.forEach(err => toast.error(err));
        return;
      }
      // If all valid → convert to array
      const price_for_attendees = Object.entries(DemonstrationsPrices).map(([key, value]) =>
        value === "" ? 0 : Number(value)
      );
      let payload = {
        medium_id: id,
        session_type: [33, 35],
        subsession_type: [99, 101],
        price_for_attendees: price_for_attendees
      };
       payload = {
             ...payload,
             session_currency: JSON.stringify({
               30: currency,
               45: currency,
               60: currency,
               452: currency,
               602: currency,
             }),
       
           };
      updateGroupPricing(payload)
        .then((data) => {
          dispatch(setLoading(false));
          if (data.data.status) {
            toast.success("Pricing Updated", { position: "top-center" });
            if (typeof onProfileUpdate === 'function') {
              onProfileUpdate(); // Call the parent function
            } else {
              console.error('onProfileUpdate is not a function');
            }
          } else {
            toast.error(data.data.message);
          }
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
          toast.error("Something went wrong");
        });
      console.log("➡️ Converted Group Prices:", payload);

    }



  };
  return (
    <div className="pricing-card">
      <Formik
        enableReinitialize // 👈 very important!
        initialValues={{
          session_currency: stepOneData && stepOneData.session_currency
            ? stepOneData.session_currency
            : "USD",
          groupPrices: {
            "Group Coaching": stepOneData && stepOneData.group_coaching ? stepOneData.group_coaching : 0,
            "Coached Practice Circles": stepOneData && stepOneData.coached_practice_circles ? stepOneData.coached_practice_circles : 0,
            "Speaker Events": stepOneData && stepOneData.speaker_events ? stepOneData.speaker_events : 0,
          },
          DemonstrationsPrices: {
            "Practice Demo": stepOneData && stepOneData.demo_practice ? stepOneData.demo_practice : 0,
            "Professional Demo": stepOneData && stepOneData.demo_professional ? stepOneData.demo_professional : 0,

          },
          ExtraServicesPricing:
            stepOneData && stepOneData.extra_services_list
              ? stepOneData.extra_services_list.reduce((acc, item) => {
                acc[item.name] =
                  item.amount !== null && item.amount !== undefined ? item.amount : "";
                return acc;
              }, {})
              : {},
        }}
        onSubmit={(values) => {
          console.log("Formik form values:", values);
          //handleSubmit(values);
          // call your save API here
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          touched,
        }) => (
          <Form>
            <div className="pricing-card-intro">
              <p className="pricing-card-desc">Please enter pricing as per the session length below.</p>
              <div className="pricing-note-box">
                <p className="pricing-note-text">Note: Pricing may be adjusted on this pricing page or within each service schedule and applies to all payment methods, including Pay It Forward.</p>
              </div>
            </div>

            {practiceDemos && (
              <div className="pricing-row">
                <div className="pricing-row-label">
                  <span className="pricing-accent-bar"></span>
                  <label>Practice Demo</label>
                </div>
                <div className="pricing-amount-box">
                  <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                  <Field
                    type="text"
                    name="DemonstrationsPrices.Practice Demo"
                    className="amount_input pricing-amount-input"
                    placeholder="0.00"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </div>
              </div>
            )}

            {publicDemo && (
              <div className="pricing-row">
                <div className="pricing-row-label">
                  <span className="pricing-accent-bar"></span>
                  <label>Professional Demonstrations</label>
                </div>
                <div className="pricing-amount-box">
                  <span className="pricing-currency-chip">{values.session_currency || 'USD'}</span>
                  <Field
                    type="text"
                    name="DemonstrationsPrices.Professional Demo"
                    className="amount_input pricing-amount-input"
                    placeholder="0.00"
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                  />
                </div>
              </div>
            )}

            <div className="pricing-row pricing-row-currency">
              <div className="pricing-row-label">
                <span className="pricing-accent-bar"></span>
                <label>Session Currency</label>
              </div>
              <div className="pricing-currency-group">
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_usd"
                    value="USD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "USD"}
                  />
                  <label htmlFor="session_currency_usd">USD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_cad"
                    value="CAD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "CAD"}
                  />
                  <label htmlFor="session_currency_cad">CAD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_aud"
                    value="AUD"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "AUD"}
                  />
                  <label htmlFor="session_currency_aud">AUD</label>
                </span>
                <span className="pricing-currency-pill">
                  <input
                    type="radio"
                    className="pricing-currency-input"
                    name="session_currency"
                    id="session_currency_eur"
                    value="EUR"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    checked={values.session_currency === "EUR"}
                  />
                  <label htmlFor="session_currency_eur">EUR</label>
                </span>
              </div>
            </div>

            <span className="error text-left">
              {errors.currency &&
                touched.currency &&
                errors.currency}
            </span>

            <div className="pricing-card-footer">
              <button type="submit" className="resend-btn pricing-update-btn" onClick={() => handleSectionSubmit("Demo", values)}>
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
